const cache = new WeakMap();
import sum from "hash-sum";

export default function withDefaultProps(Component, defaultProps, config) {
  let hash = sum({ defaultProps, config });
  let cached;
  if (cache.has(Component)) {
    cached = cache.get(Component);
    if (cached[hash]) {
      return cached[hash];
    }
  } else {
    cached = {};
    cache.set(Component, cached);
  }
  let displayName = `WithDefaultProps(${
    Component.displayName || Component.name || "Component"
  })`;
  const component = ({ ...ownProps }) => (
    <Component {...defaultProps} {...ownProps} />
  );
  component.displayName = displayName;
  component.wsuiConfig = { ...Component.wsuiConfig, ...config };
  cached[hash] = component;
  return component;
}
